











import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import { sumptionRatio } from '@/api/home'
// import { getColors } from '@/utils'
import NoData from '@/components/NoData'

const echarts = require('echarts')
@Component({
  name: 'ConsumptionStructure',
  components:{NoData}
})
export default class ConsumptionStructure extends Vue {
    @Prop({default:''}) code!:string
  private data : any = []
  sumptionRatioData(e:any){
    sumptionRatio({
      regionCode:e,
      unitType:1
    }).then((res :any)=>{
      if(res.status == 0){
        this.data = []
        res.data.forEach((item:any) =>{
          this.data.push({
            name:item.energyName,
            value:item.dataValue,
            ratio:item.ratio
          })
        })
        this.init()
      }
    //   if(!res.data){
    //     this.data = null
    //   }
    }).catch(err =>{
    })
  }
  private init() {
      const main = document.getElementById('ConsumptionStructure')
      // 基于准备好的dom，初始化echarts实例
      const myChart:any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        // color: getColors(), 
        tooltip: {},
        grid: {
          top:0,
          containLabel: true
        },
        legend: {
            // orient: 'vertical',
            icon: 'circle',
            itemWidth: 10,  // 设置宽度
            itemHeight: 10, // 设置高度
            left: 'center',
            bottom:0
            // bottom: 'bottom',
        },
        series: [
          {
            name: '',
            type: 'pie',
            clockwise:false,
            radius: '60%',
            center:['50%','45%'],
            data: this.data,
            itemStyle: {
                normal: {
                    label: {        //此处为指示线文字
                        show: true,
                        // position: 'inner', //标签的位置
                        textStyle: {
                            fontWeight: 200,
                            fontSize: 10    //文字的字体大小
                        },
                        formatter: function (p:any) {   //指示线对应文字
                            return Number(p.data.ratio * 100).toFixed(2) +'%'
                        }
                    },
                    labelLine: {    //指示线状态
                        show: true,
                        smooth: 0.2,
                        length: 10,
                        length2: 20
                    }
                }
            },
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
          }
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option)
  }
  updatafun(){
    setTimeout(() => {
      this.init()
    }, 0)
  }
    @Watch('code')
    onChangeData(e:any) {
        this.sumptionRatioData(e)
    }
    mounted() {
        this.sumptionRatioData(this.code)
    }
}


